import shape02 from "../../../Assets/img/shape02.svg";
import shape05 from "../../../Assets/img/shape05.svg";
import shape06 from "../../../Assets/img/shape06.svg";
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { SegInput } from '../../../Components/SegUI/SegInput/SegInputLanding';
import CodigosDeArea from '../../../Assets/CodigosDeArea.json';
import { useState } from 'react';
import styled from '@emotion/styled';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { buscarTextoSeo } from '../../../utils/buscarTextoSeo';
import sendArrepentimiento from '../../../Services/API/Arrepentimiento';
import { SegButton } from '../../../Components/SegUI/SegButton/SegButton';
import useSEOConfig from '../../../hooks/seo/useSEOConfig';
import { Navbar } from '../Components/Navbar';
import { useConfig } from "../../../context/ConfigContext";
import { getRecaptchaKey } from "../../../Services/API/helper";


type FormValues = {
    nombre: string;
    apellido: string;
    email: string;
    prefijo: string;
    telefono: string;
    tipo_doc: string;
    documento: string;
    dia: string;
    mes: string;
    anio: string;
    motivo_arrepentimiento: string;
    terminos: boolean;
};

const StyledDiv = styled.div`
  display: block;
  text-align: left;
  font-size: 1rem;
  color: var(--bs-form-invalid-color);
  margin: 0 auto;
  margin-top: 0.25rem;
`;

export const FormularioArrepentimiento = () => {
    const { config } = useConfig()
    const location = useLocation();
    const textoSeo = buscarTextoSeo(location.pathname, config.pais);
    const { handleSubmit, register, control, setValue, getValues, formState: { errors }, trigger, setError, clearErrors, watch, formState } =
        useForm<FormValues>();
    const [isTelefonoValido, setIsTelefonoValido] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate();
    const isUY = config.pais === "UY";

    const validarTelefono = (isUY: boolean, prefijo: string, numero: string) => {
        if (isUY) {
            // Uruguay → solo número, 8 o 9 dígitos
            return /^[0-9]{8,9}$/.test(numero || "");
        }

        // Argentina → prefijo + número deben dar exactamente 10 dígitos
        const numeroCompleto = (prefijo || "") + (numero || "");
        return numeroCompleto.length === 10 && /^[0-9]+$/.test(numeroCompleto);
    };

    const validarYActualizarTelefono = () => {
        const { prefijo, telefono } = getValues();
        const resultadoValidarTelefono = validarTelefono(isUY, prefijo, telefono);
        setIsTelefonoValido(resultadoValidarTelefono);
    };
    const obtenerTokenRecaptcha = (key: any): Promise<string> => {
        return new Promise((resolve, reject) => {
            grecaptcha.ready(function () {
                grecaptcha.execute(key!, { action: 'submit' }).then(function (token) {
                    resolve(token)
                });
            });
        });
    };
    const onSubmit: SubmitHandler<FormValues> = async (data) => {
        setIsLoading(true)
        const createFormattedString = (data: FormValues) => {
            const {
                nombre,
                apellido,
                email,
                prefijo,
                telefono,
                tipo_doc,
                documento,
                dia,
                mes,
                anio,
                motivo_arrepentimiento,
                terminos
            } = data;

            return `
            <!DOCTYPE html>
            <html>
            <head>
                <meta charset="UTF-8">
                <title>Formulario de Arrepentimiento</title>
            </head>
            <body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
                <div style="max-width: 600px; margin: 0 auto; padding: 20px;">
                    <div style="margin-bottom: 20px;">
                        <h2 style="color: #2c3e50; border-bottom: 2px solid #3498db; padding-bottom: 10px;">DATOS PERSONALES</h2>
                        <p><strong>Nombre:</strong> ${nombre}</p>
                        <p><strong>Apellido:</strong> ${apellido}</p>
                        <p><strong>Email:</strong> ${email}</p>
                        <p><strong>Teléfono:</strong> (${prefijo}) ${telefono}</p>
                    </div>
            
                    <div style="margin-bottom: 20px;">
                        <h2 style="color: #2c3e50; border-bottom: 2px solid #3498db; padding-bottom: 10px;">DOCUMENTACIÓN</h2>
                        <p><strong>Tipo de documento:</strong> ${tipo_doc}</p>
                        <p><strong>Número:</strong> ${documento}</p>
                    </div>
            
                    <div style="margin-bottom: 20px;">
                        <h2 style="color: #2c3e50; border-bottom: 2px solid #3498db; padding-bottom: 10px;">INFORMACIÓN DE CONTRATACIÓN</h2>
                        <p><strong>Fecha de contratación:</strong> ${dia}/${mes}/${anio}</p>
                        <p><strong>Motivo:</strong> ${motivo_arrepentimiento}</p>
                    </div>
            
                    <div style="margin-bottom: 20px;">
                        <h2 style="color: #2c3e50; border-bottom: 2px solid #3498db; padding-bottom: 10px;">CONFIRMACIÓN</h2>
                        <p>${terminos ? 'Acepta' : ''} Políticas de privacidad</p>
                    </div>
                </div>
            </body>
            </html>`;
        }
        const dataString = createFormattedString(data) || "";

        const key = await getRecaptchaKey()
        obtenerTokenRecaptcha(key).then((token: string) => {
            if (dataString !== "") {
                const fetchData = async () => {
                    const response: any = await sendArrepentimiento(dataString, token);
                    if (response?.data) {
                        if (response.data.api_status === 200 && response.data.api_data !== null) {
                            navigate("/formulario-arrepentimiento-enviado")
                        } else if (response.data.api_data === "El Captcha no es válido") {
                            setIsLoading(false)
                            console.log('Error en el captcha')
                        } else {
                            console.error("Error al guardar contacto")
                            setIsLoading(false)
                        }
                    } else {
                        setIsLoading(false)
                    }
                }
                fetchData();
            }
        })
    }

    useSEOConfig(
        {
            title: textoSeo?.title ?? "Formulario de Arrepentimiento - Segurarse",
             description: textoSeo?.description ?? (config.pais === "UY" ?
            "Formulario de revocación de aceptación del seguro contratado conforme a la Ley 17250. Complete el formulario para ejercer su derecho de arrepentimiento en Segurarse."
            :
            "Formulario de revocación de aceptación del seguro contratado según Resolución 424/2020 de la Secretaría de Comercio Interior. Complete el formulario para ejercer su derecho de arrepentimiento en Segurarse."),
            tituloCompleto: !!textoSeo,
            keywords: "formulario de arrepentimiento, revocación de seguro, Segurarse, Resolución 424/2020, derecho de arrepentimiento, ecommerce Segurarse",
            ogTitle: "Formulario de Arrepentimiento - Segurarse",
            ogDescription: "Complete el formulario de arrepentimiento para revocar su aceptación del seguro contratado en Segurarse conforme a la Resolución 424/2020 de la Secretaría de Comercio Interior.",
            twitterTitle: "Formulario de Arrepentimiento - Segurarse",
            twitterDescription: "Complete el formulario de arrepentimiento para revocar su aceptación del seguro contratado en Segurarse conforme a la Resolución 424/2020 de la Secretaría de Comercio Interior."
        }
    )

    return (
        <>
            <Navbar rubro='auto' />
            <main className='bg-white'>
                <div className="position-relative pt-45 pb-25 pt-lg-80 pb-lg-35">
                    <img className="d-none d-lg-block pos02" src={shape02} alt='' />
                    <div className="container">
                        <h1 className="ff-mukta fw-bold fs-30 fs-lg-36 lh-lg-1 text-black text-center text-lg-start mb-10">Formulario de arrepentimiento</h1>
                        <div className="col-md-10 col-lg-8 mx-auto mx-lg-0">
                            <p className="fs-14 fs-lg-16 text-black text-center text-lg-start mb-0">
                                {
                                    config.pais === "AR" &&
                                    <>
                                        Conforme Resolución 424/2020, de la secretaria de Comercio Interior, las y los clientes pueden solicitar la revocación de la aceptación durante el plazo de DIEZ (10) días corridos contados a partir de la fecha de la celebración del seguro contratado únicamente mediante el canal ecommerce de la web (<a className='text-decoration-underline' href='https://segurarse.com.ar/' target='_blank'>www.segurarse.com.ar</a>).
                                    </>
                                }
                                {
                                    config.pais === "UY" &&
                                    <>
                                        Conforme a la Ley 17.250, los clientes pueden solicitar la resolución o rescisión -de pleno derecho- del contrato celebrado vía online con SEGURARSE, dentro del plazo máximo de CINCO (5) días hábiles contados a partir de la fecha de la celebración del seguro contratado, mediante correo electrónico a la casilla <a className="text-decoration-underline" href="mailto:compliance@segurarse.com.uy"> compliance@segurarse.com.uy</a> o mediante el canal e-commerce de la web (<a className='text-decoration-underline' href='https://segurarse.com.uy/' target='_blank'>www.segurarse.com.uy</a>).
                                    </>

                                }
                            </p>
                        </div>
                    </div>
                </div>

                <div className="pt-25 pb-80">
                    <div className="container">
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            className="bg-f8 rounded-3 px-3 px-sm-5 py-25">
                            <div className="row gx-lg-5">

                                <div className="col-lg-6">

                                    <div className="mb-20">
                                        <div className="fs-14 fw-bold text-black mb-1">¿Cuál es tu nombre?*</div>

                                        <Controller
                                            name="nombre"
                                            control={control}
                                            rules={{
                                                validate: {
                                                    required: (value) => !!value || "Ingresá el nombre",
                                                    pattern: (value) =>
                                                        /^[a-zA-ZáéíóúüñÁÉÍÓÚÜÑ\s]+$/.test(value) ||
                                                        "Nombre inválido",
                                                },
                                            }}
                                            render={({ field, fieldState }) => (
                                                <SegInput
                                                    id="nombre"
                                                    className="fs-16"
                                                    fontSize="fs-16"
                                                    label=""
                                                    name="nombre"
                                                    type="text"
                                                    width={100}
                                                    placeHolder="Ej: Juan"
                                                    onChange={(e) => {
                                                        field.onChange(e);
                                                        setValue("nombre", e.target.value); // Actualiza el valor en React Hook Form
                                                        trigger("nombre");
                                                    }}
                                                    value={field.value}
                                                    autoFocus={true}
                                                    leyendaError={fieldState?.error?.message}
                                                    borderColor={`${formState.errors.nombre
                                                        ? "var(--bs-form-invalid-border-color)"
                                                        : ""
                                                        }`}
                                                    focusBorderColor={`${formState.errors.nombre
                                                        ? "var(--bs-form-invalid-border-color)"
                                                        : "#2c7dfd"
                                                        }`}
                                                />
                                            )}

                                        />
                                    </div>

                                    <div className="mb-20">
                                        <div className="fs-14 fw-bold text-black mb-1">¿Tu apellido?*</div>
                                        <Controller
                                            name="apellido"
                                            control={control}
                                            rules={{
                                                validate: {
                                                    required: (value) => !!value || "Ingresá el apellido",
                                                    pattern: (value) =>
                                                        /^[a-zA-ZáéíóúüñÁÉÍÓÚÜÑ\s]+$/.test(value) ||
                                                        "Apellido inválido",
                                                },
                                            }}
                                            render={({ field, fieldState }) => (
                                                <SegInput
                                                    id="apellido"
                                                    className="fs-16"
                                                    fontSize="fs-16"
                                                    label=''
                                                    width={100}
                                                    name="apellido"
                                                    type="text"
                                                    placeHolder="Ej: Perez"
                                                    onChange={(e) => {
                                                        field.onChange(e);
                                                        setValue("apellido", e.target.value); // Actualiza el valor en React Hook Form
                                                        trigger("apellido");
                                                    }}
                                                    value={field.value}
                                                    autoFocus={false}
                                                    leyendaError={fieldState?.error?.message}
                                                    borderColor={`${formState.errors.apellido
                                                        ? "var(--bs-form-invalid-border-color)"
                                                        : ""
                                                        }`}
                                                    focusBorderColor={`${formState.errors.apellido
                                                        ? "var(--bs-form-invalid-border-color)"
                                                        : "#2c7dfd"
                                                        }`}
                                                />
                                            )}

                                        />
                                    </div>

                                    <div className="mb-20">
                                        <div className="fs-14 fw-bold text-black mb-1">¿Tu email?*</div>

                                        <Controller
                                            name="email"
                                            control={control}
                                            rules={{
                                                validate: {
                                                    required: (value) => (!!value || "Ingresá el email"),
                                                    pattern: (value) =>
                                                        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
                                                            value
                                                        ) || "Email inválido",
                                                },
                                            }}
                                            render={({ field, fieldState }) =>
                                                <SegInput
                                                    id="email"
                                                    className="fs-16"
                                                    fontSize="fs-16"
                                                    label=''
                                                    width={100}
                                                    name="email"
                                                    type="text"
                                                    placeHolder="Ej: juanperez@gmail.com"
                                                    onChange={(e) => {
                                                        field.onChange(e);
                                                        setValue("email", e.target.value); // Actualiza el valor en React Hook Form
                                                        trigger("email");
                                                    }}
                                                    value={field.value}
                                                    autoFocus={false}
                                                    leyendaError={fieldState?.error?.message}
                                                    borderColor={`${formState.errors.email
                                                        ? "var(--bs-form-invalid-border-color)"
                                                        : ""
                                                        }`}
                                                    focusBorderColor={`${formState.errors.email
                                                        ? "var(--bs-form-invalid-border-color)"
                                                        : "#2c7dfd"
                                                        }`}
                                                />
                                            }
                                        />


                                    </div>

                                    <div className="mb-20">
                                        <div className="fs-14 fw-bold text-black mb-1">¿Tu teléfono celular?*</div>
                                        <div className={(window.innerWidth > 768) ? "row g-2" : ""}>
                                            {/* ✅ Prefijo solo si es AR */}
                                            {config.pais === "AR" && (
                                                <div className={(window.innerWidth > 768) ? "col-3" : "col-12"}>
                                                    <div className="input-group">
                                                        <div className="fs-14 text-6e mb-1">Cod. Área</div>
                                                        <Controller
                                                            name="prefijo"
                                                            control={control}
                                                            rules={{
                                                                validate: {
                                                                    required: (value) => !!value || "Ingresá el Cód. Área",
                                                                    isInValidCodeArea: (value) =>
                                                                        CodigosDeArea.includes(value) || "Cód. Área inválido",
                                                                },
                                                            }}
                                                            render={({ field, fieldState }) => (
                                                                <SegInput
                                                                    isGroup={true}
                                                                    labelGroup="0"
                                                                    className="fs-16"
                                                                    fontSize="fs-16"
                                                                    label=""
                                                                    name="prefijo"
                                                                    type="number"
                                                                    width={100}
                                                                    placeHolder="11"
                                                                    value={field.value}
                                                                    onKeyDown={(e) => {
                                                                        if (["e", "E", "+", "-"].includes(e.key)) e.preventDefault();
                                                                    }}
                                                                    onChange={(e) => {
                                                                        field.onChange(e);
                                                                        setValue("prefijo", e.target.value);
                                                                        trigger("prefijo");
                                                                        const numero = getValues("telefono");
                                                                        if (
                                                                            numero !== "" &&
                                                                            !validarTelefono(config.pais === "UY", e.target.value, numero)
                                                                        ) {
                                                                            setError("telefono", { type: "validate", message: "Número inválido" });
                                                                        } else {
                                                                            clearErrors("telefono");
                                                                        }
                                                                        validarYActualizarTelefono();
                                                                    }}
                                                                    leyendaError={fieldState?.error?.message}
                                                                    borderColor={`${errors.prefijo ? "var(--bs-form-invalid-border-color)" : ""}`}
                                                                    focusBorderColor={`${errors.prefijo ? "var(--bs-form-invalid-border-color)" : "#2c7dfd"}`}
                                                                />
                                                            )}
                                                        />
                                                    </div>
                                                </div>
                                            )}

                                            {/* ✅ Número */}
                                            <div className={(window.innerWidth > 768) ? (config.pais === "AR" ? "col-9" : "col-12") : "col-12 mt-2"}>
                                                <div className="fs-14 text-6e mb-1">Número de teléfono</div>
                                                <Controller
                                                    name="telefono"
                                                    control={control}
                                                    rules={{
                                                        validate: {
                                                            required: (value) => !!value || "Ingresá Número de Celular",
                                                            // Diferente regex según país
                                                            pattern: (value) =>
                                                                (config.pais === "UY"
                                                                    ? /^[0-9]{8,9}$/ // UY → 8 o 9 dígitos
                                                                    : /^[0-9]{6,9}$/ // AR → 6 a 9 dígitos (más prefijo)
                                                                ).test(value || "") || "Número inválido",
                                                            validateCombination: (value) => {
                                                                if (config.pais === "UY") return true; // no combinamos
                                                                const prefijo = watch("prefijo");
                                                                if ((String(prefijo || "") + String(value || "")).length !== 10)
                                                                    return "Número inválido";
                                                                return true;
                                                            },
                                                        },
                                                    }}
                                                    render={({ field, fieldState }) => (
                                                        <SegInput
                                                            isGroup={true}
                                                            labelGroup={config.pais === "UY" ? "9" : "15"}
                                                            className="fs-16"
                                                            fontSize="fs-16"
                                                            label=""
                                                            name="telefono"
                                                            type={config.pais === "UY" ? "tel" : "number"}
                                                            width={100}
                                                            placeHolder="33669955"
                                                            value={field.value}
                                                            onKeyDown={(e) => {
                                                                if (["e", "E", "+", "-"].includes(e.key)) e.preventDefault();
                                                            }}
                                                            onChange={(e) => {
                                                                field.onChange(e);
                                                                setValue("telefono", e.target.value);
                                                                trigger("telefono");
                                                                validarYActualizarTelefono();
                                                            }}
                                                            leyendaError={fieldState?.error?.message}
                                                            borderColor={`${errors.telefono ? "var(--bs-form-invalid-border-color)" : ""}`}
                                                            focusBorderColor={`${errors.telefono ? "var(--bs-form-invalid-border-color)" : "#2c7dfd"}`}
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </div>


                                <div className="col-lg-6">

                                    <div className="mb-20">
                                        <div className="fs-14 fw-bold text-black mb-1">Ingresá tu documento*</div>
                                        <div className={(window.innerWidth > 768) ? "row g-2" : ""}>
                                            <div className={(window.innerWidth > 768) ? "col-3" : "col-12"}>
                                                <div className="fs-13 text-6e mb-1">Tipo</div>

                                                <select className="form-select fs-14"
                                                    {...register("tipo_doc",
                                                        { required: "Selecciná un tipo" })
                                                    }
                                                >
                                                    {config.pais === "UY" ?
                                                        <>
                                                            <option value={"RUT"}>RUT</option>
                                                            <option value={"CEDULA"}>Cédula</option>
                                                        </>
                                                        :
                                                        <>
                                                            <option value={"DNI"}>DNI</option>
                                                            <option value={"CUIT"}>CUIT</option>
                                                        </>
                                                    }
                                                </select>
                                                {
                                                    errors.tipo_doc &&
                                                    <StyledDiv className="error">{errors.tipo_doc.message}</StyledDiv>
                                                }
                                            </div>
                                            <div className={(window.innerWidth > 768) ? "col-9" : "col-12 mt-2"}>
                                                <div className="fs-13 text-6e mb-1">Nº sin puntos, guiones ni espacios</div>
                                                <Controller
                                                    name="documento"
                                                    control={control}
                                                    rules={{
                                                        validate: {
                                                            required: (value) => {
                                                                if (!value) {
                                                                    return "Ingresá el Número"
                                                                } else {
                                                                }
                                                            },
                                                            pattern: (value) => {
                                                                const tipoDoc = getValues("tipo_doc");
                                                                if (tipoDoc === 'DNI') {
                                                                    if (/^\d{7,8}$/.test(value)) {
                                                                    } else {
                                                                        return "DNI inválido"
                                                                    }
                                                                } else if (tipoDoc === 'CUIT' || tipoDoc === 'CUIL') {
                                                                    if (/^(20|2[3-7]|30|3[3-4])\d{8}[0-9]$/.test(value)) {
                                                                    } else {
                                                                        return `Documento inválido`
                                                                    }
                                                                }

                                                                // Uruguay
                                                                else if (tipoDoc === "CEDULA") {
                                                                    if (!/^\d{7,8}$/.test(value)) return "Cédula inválida";
                                                                } else if (tipoDoc === "RUT") {
                                                                    if (!/^\d{12}$/.test(value)) return "RUT inválido";
                                                                }
                                                            }
                                                        },
                                                    }}
                                                    render={({ field, fieldState }) => (
                                                        <SegInput
                                                            id="documento"
                                                            className="fs-14"
                                                            fontSize="fs-16"
                                                            placeHolder='42340099'
                                                            label=""
                                                            name="documento"
                                                            type="number"
                                                            width={100}
                                                            onKeyDown={(event) => {
                                                                if (event.key === "e" || event.key === "E") {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                            onChange={(e) => {
                                                                field.onChange(e);
                                                                setValue("documento", e.target.value); // Actualiza el valor en React Hook Form
                                                                trigger("documento");
                                                            }}
                                                            value={field.value}
                                                            autoFocus={false}
                                                            leyendaError={fieldState?.error?.message}
                                                            borderColor={`${formState.errors.documento
                                                                ? "var(--bs-form-invalid-border-color)"
                                                                : ""
                                                                }`}
                                                            focusBorderColor={`${formState.errors.documento
                                                                ? "var(--bs-form-invalid-border-color)"
                                                                : "#2c7dfd"
                                                                }`}
                                                        />
                                                    )}

                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mb-20">
                                        <div className="fs-14 fw-bold text-black mb-1">Fecha de contratación*</div>
                                        <div className="fs-13 text-black mb-1">Indicar la fecha de emisión, la que figura en tu póliza</div>
                                        <div className="row g-2">
                                            <div className="col-4">
                                                <div className="fs-13 text-6e mb-1">Día</div>
                                                <Controller
                                                    name="dia"
                                                    control={control}
                                                    rules={{
                                                        validate: {
                                                            customValidation: (value) => {
                                                                if (!value) {
                                                                    return "Día debe incluir 2 dígitos";
                                                                }
                                                                const parsedValue = parseInt(value, 10);
                                                                if (isNaN(parsedValue) || parsedValue > 31) {
                                                                    return "Día no puede ser mayor a 31";
                                                                }
                                                                if (isNaN(parsedValue) || parsedValue <= 0) {
                                                                    return "Día no puede ser 0";
                                                                }
                                                                const isSingleDigitWithoutZero = /^[0-9]$/.test(value);
                                                                if (isSingleDigitWithoutZero) {
                                                                    return "Día debe incluir 2 dígitos";
                                                                }
                                                                return true; // La validación es exitosa
                                                            },
                                                        },
                                                    }}
                                                    render={({ field, fieldState }) => (
                                                        <SegInput

                                                            label=""
                                                            name="dia"
                                                            type="number"
                                                            width={100}
                                                            fontSize="fs-16"
                                                            placeHolder="DD"
                                                            value={field.value}
                                                            autoFocus={false}
                                                            onKeyDown={(event) => {
                                                                if (event.key === "e" || event.key === "E") {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                            onChange={(e) => {
                                                                const trimmedValue = e.target.value.slice(0, 2).replace(/[^0-9]/g, '');
                                                                field.onChange(trimmedValue);
                                                                setValue("dia", trimmedValue);
                                                                trigger("dia");
                                                                if (trimmedValue.length === 2) {
                                                                    const nextInput = document.querySelector('input[name="mes"]') as HTMLInputElement;
                                                                    nextInput?.focus();
                                                                }
                                                            }}
                                                            leyendaError={fieldState?.error?.message}
                                                            borderColor={`${formState.errors.dia
                                                                ? "var(--bs-form-invalid-border-color)"
                                                                : ""
                                                                }`}
                                                            focusBorderColor={`${formState.errors.dia
                                                                ? "var(--bs-form-invalid-border-color)"
                                                                : "#2c7dfd"
                                                                }`}
                                                        />
                                                    )}
                                                />
                                            </div>


                                            <div className="col-4">
                                                <div className="fs-13 text-6e mb-1">Mes</div>

                                                <Controller
                                                    name="mes"
                                                    control={control}
                                                    rules={{
                                                        validate: {
                                                            customValidation: (value) => {
                                                                if (!value) {
                                                                    return "Mes debe incluir 2 dígitos";
                                                                }
                                                                const parsedValue = parseInt(value, 10);
                                                                if (isNaN(parsedValue) || parsedValue > 12) {
                                                                    return "Mes no puede ser mayor a 12";
                                                                }
                                                                if (isNaN(parsedValue) || parsedValue <= 0) {
                                                                    return "Día no puede ser 0";
                                                                }
                                                                const isSingleDigitWithoutZero = /^[0-9]$/.test(value);
                                                                if (isSingleDigitWithoutZero) {
                                                                    return "Mes debe incluir 2 dígitos";
                                                                }
                                                                return true; // La validación es exitosa
                                                            },
                                                        },
                                                    }}
                                                    render={({ field, fieldState }) => (
                                                        <SegInput
                                                            label=""
                                                            name="mes"
                                                            type="number"
                                                            fontSize="fs-16"
                                                            width={100}
                                                            placeHolder="MM"
                                                            value={field.value}
                                                            onKeyDown={(event) => {
                                                                if (event.key === "e" || event.key === "E") {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                            autoFocus={false}
                                                            onChange={(e) => {
                                                                const trimmedValue = e.target.value.slice(0, 2).replace(/[^0-9]/g, '');
                                                                field.onChange(trimmedValue);
                                                                setValue("mes", trimmedValue);
                                                                trigger("mes");
                                                                if (trimmedValue.length === 2) {
                                                                    const nextInput = document.querySelector('input[name="anio"]') as HTMLInputElement;
                                                                    nextInput?.focus();
                                                                }
                                                            }}
                                                            leyendaError={fieldState?.error?.message}
                                                            borderColor={`${formState.errors.mes
                                                                ? "var(--bs-form-invalid-border-color)"
                                                                : ""
                                                                }`}
                                                            focusBorderColor={`${formState.errors.mes
                                                                ? "var(--bs-form-invalid-border-color)"
                                                                : "#2c7dfd"
                                                                }`}
                                                        />
                                                    )}
                                                />
                                            </div>

                                            <div className="col-4">
                                                <div className="fs-13 text-6e mb-1">Año</div>

                                                <Controller
                                                    name="anio"
                                                    control={control}
                                                    rules={{
                                                        validate: {
                                                            required: (value) =>
                                                                !!value || "Ingresá el año de nacimiento",
                                                            pattern: (value) =>
                                                                /^(19\d{2}|20\d{2})$/.test(value) || "Año debe incluir 4 dígitos",
                                                        },
                                                    }}
                                                    render={({ field, fieldState }) => (
                                                        <SegInput
                                                            label=""
                                                            name="anio"
                                                            type="number"
                                                            fontSize="fs-16"
                                                            placeHolder="AAAA"
                                                            value={field.value}
                                                            onKeyDown={(event) => {
                                                                if (event.key === "e" || event.key === "E") {
                                                                    event.preventDefault();
                                                                }
                                                            }}
                                                            autoFocus={false}
                                                            onChange={(e) => {
                                                                const trimmedValue = e.target.value.slice(0, 4).replace(/[^0-9]/g, '');
                                                                field.onChange(trimmedValue);
                                                                setValue("anio", trimmedValue); // Actualiza el valor en React Hook Form
                                                                trigger("anio");
                                                            }}
                                                            width={100}
                                                            leyendaError={fieldState?.error?.message}
                                                            borderColor={`${formState.errors.anio
                                                                ? "var(--bs-form-invalid-border-color)"
                                                                : ""
                                                                }`}
                                                            focusBorderColor={`${formState.errors.anio
                                                                ? "var(--bs-form-invalid-border-color)"
                                                                : "#2c7dfd"
                                                                }`}
                                                        />
                                                    )}
                                                />
                                            </div>


                                        </div>
                                    </div>

                                    <div className="mb-20">
                                        <div className="fs-14 fw-bold text-black mb-1">Seleccioná el motivo por el cual te arrepentiste de tu seguro*</div>
                                        <select className="form-select fs-14"
                                            {...register("motivo_arrepentimiento",
                                                { required: "El motivo es requerido", })
                                            }>
                                            <option value="">Seleccioná una opción</option>
                                            <option value="Seguro no contratado">Seguro no contratado</option>
                                            <option value="Costo elevado">Costo elevado</option>
                                            <option value="Disconformidad con el servicio">Disconformidad con el servicio</option>
                                            <option value="Contraté otro seguro">Contraté otro seguro</option>
                                            <option value="Otros">Otros</option>
                                        </select>
                                        {
                                            errors.motivo_arrepentimiento &&
                                            <StyledDiv className="error">{errors.motivo_arrepentimiento.message}</StyledDiv>
                                        }
                                    </div>

                                    <div className="mb-20">
                                        <div className="form-check">
                                            <input
                                                {...register("terminos",
                                                    { required: "Este campo es requerido", })
                                                }
                                                className="form-check-input"
                                                type="checkbox"
                                                value=""
                                                id="flexCheckDefault" />
                                            <label className="form-check-label text-6e fs-12" htmlFor="flexCheckDefault">
                                                He leído y acepto las <a className="text-decoration-underline" href="/politicas-privacidad" target="_blank">políticas de privacidad</a>
                                            </label>
                                        </div>
                                        {
                                            errors.terminos &&
                                            <StyledDiv className="error">{errors.terminos.message}</StyledDiv>
                                        }
                                    </div>

                                </div>


                                <div>
                                    <div className="text-center pt-3">
                                        <SegButton
                                            label="Enviar"
                                            type="submit"
                                            className="btn btn-primary fs-17 fw-bold px-45"
                                            disabled={
                                                !formState.isValid // Verifica si el formulario es válido
                                            }
                                            loading={isLoading}
                                        />
                                    </div>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>

                <div className="bg-f4 py-30 py-lg-50 position-relative">
                    <img className="d-none d-lg-block pos07 bottom-0" src={shape05} alt='' />
                    <img className="d-none d-lg-block pos06" src={shape06} alt='' />
                    <div className="container px-lg-5">
                        <div className="row justify-content-evenly">
                            <div className="col-lg-auto text-center text-lg-start">
                                <h2 className="ff-mukta fw-bold fs-30 fs-lg-40 text-black mb-lg-1">¿No resolvimos<br className="d-sm-none" /> tu consulta?</h2>
                                <p className="fw-bold fs-25 fs-lg-25 text-primary mb-18 mb-lg-0">¡Estamos para vos!</p>
                            </div>
                            <div className="col-lg-auto text-center text-lg-left">
                                <Link
                                    to="/contacto"
                                    className="transition-base d-inline-block w-250p py-12 rounded-3 fs-22 fs-lg-24 fw-bold lh-1 text-center bg-primary bg-lg-gray-dark hover-bg-primary text-white"
                                >
                                    CONTACTO
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}
